export * from "./getOrderAttributesWithZipCodeResponse.mock";
